import axios from 'axios';
import { getApiBaseUrl } from '../../../../utils/apiConfig';
import ProductModel from '../models/ProductModel';
import { toBooleanFromBit } from './productHelpers';
import { normalizeDetailTabsFromApi } from './productDetailTabKeys';

let cachedActiveTabTypes = null;
let activeTabTypesPromise = null;

export const getActiveDetailTabTypes = async (forceRefresh = false) => {
  if (!forceRefresh && cachedActiveTabTypes) {
    return cachedActiveTabTypes;
  }
  if (!forceRefresh && activeTabTypesPromise) {
    return activeTabTypesPromise;
  }

  activeTabTypesPromise = axios
    .get(`${getApiBaseUrl()}/ec-product-detail-tab-type/getActive`)
    .then((response) => {
      cachedActiveTabTypes = response.data?.data || [];
      return cachedActiveTabTypes;
    })
    .catch(() => [])
    .finally(() => {
      activeTabTypesPromise = null;
    });

  return activeTabTypesPromise;
};

export const mapProductFromApi = (data, activeTabTypes = []) => {
  if (!data) return new ProductModel();
  return {
    ...new ProductModel(),
    ...data,
    CategoryId: data.CategoryId ?? null,
    IsActive: toBooleanFromBit(data.IsActive, true),
    IsPromoBanner: toBooleanFromBit(data.IsPromoBanner, false),
    IsFreeDelivery: toBooleanFromBit(data.IsFreeDelivery, false),
    Images: data.Images || [],
    Features: data.Features || [],
    Specifications: data.Specifications || [],
    DetailTabs: normalizeDetailTabsFromApi(data.DetailTabs, activeTabTypes),
  };
};

export const mapProductFromApiAsync = async (data) => {
  const activeTabTypes = await getActiveDetailTabTypes();
  return mapProductFromApi(data, activeTabTypes);
};

export const buildProductSavePayload = (formData, userId) => ({
  ProductId: formData.ProductId || null,
  SubCategoryId: formData.SubCategoryId,
  VendorId: formData.VendorId || null,
  ProductName: formData.ProductName?.trim(),
  Slug: formData.Slug?.trim(),
  ShortDescription: formData.ShortDescription || null,
  Price: Number(formData.Price),
  OldPrice: formData.OldPrice !== '' && formData.OldPrice != null ? Number(formData.OldPrice) : null,
  Rating: formData.Rating !== '' && formData.Rating != null ? Number(formData.Rating) : null,
  RatingWidth: formData.RatingWidth || null,
  BadgeLabel: formData.BadgeLabel || null,
  BadgeClass: formData.BadgeClass || null,
  BrandName: formData.BrandName || null,
  HomepageSection: formData.HomepageSection || null,
  HomepageSectionOrder: Number(formData.HomepageSectionOrder) || 0,
  IsFreeDelivery: !!formData.IsFreeDelivery,
  IsPromoBanner: !!formData.IsPromoBanner,
  PromoBannerTitle: formData.PromoBannerTitle || null,
  PromoBannerDisplayOrder: Number(formData.PromoBannerDisplayOrder) || 0,
  IsActive: formData.IsActive !== false,
  DisplayOrder: Number(formData.DisplayOrder) || 0,
  UserId: userId,
});
